import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from "../../../features/authentication/contexts/AuthContext";
import { Box, CircularProgress, Typography } from "@mui/material";

function SubscriptionSuccess() {
    const location = useLocation();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);
    const query = searchParams.get('success');
    let auth = useAuthContext();

    useEffect(() => {
        if (query === 'true') {
          // If subscription success check if database updated yet and user has a tier
          const intervalId = setInterval(() => {
            if (auth.isBusinessUser()) {
                clearInterval(intervalId);
                navigate('/beacons');
            }
        }, 2000); // Check every 2 seconds

        return () => clearInterval(intervalId);
      } else {
        // Subscription failed send them back to subscription page
        navigate('/subscriptions');
      }
    }, [auth, navigate, query]);

    return (
      <>
        <Box sx=
        {{ 
          display: "flex",
          flexDirection: "column", 
          justifyContent: "center", 
          alignItems: "center", 
          minHeight: "100vh" 
        }}>
          <CircularProgress />
          <Typography sx={{ 
            mt: 6,
          }}>
            Please wait while we activate your subscription...
          </Typography>
        </Box>
      </>
    );
}

export default SubscriptionSuccess;
